document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.js-collection-slider');

  sliders.forEach(slider => {
    const speed = parseFloat(slider.dataset.autoplaySpeed) || 60; // px/sec
    const autoplayEnabled = slider.dataset.autoplay === "true";
    const direction = slider.dataset.direction || "left";

    if (!autoplayEnabled || slider.children.length === 0) return;

    // Save original items
    const originalItems = Array.from(slider.children);
    const totalItems = originalItems.length;

    // --- SETTINGS ---
    const visibleClones = Math.min(totalItems, 6); // max clones for loop
    const bufferItems = originalItems.slice(0, visibleClones);

    // --- Rebuild DOM with only visible items + minimal clones ---
    slider.innerHTML = '';
    originalItems.forEach(item => slider.appendChild(item)); // first batch
    bufferItems.forEach(item => slider.appendChild(item.cloneNode(true))); // minimal clones

    // --- Smooth scroll animation ---
    slider.style.scrollBehavior = 'auto';
    slider.style.scrollSnapType = 'none';

    let rafId = null;
    let lastTime = null;
    let paused = false;

    function step(time) {
      if (paused) {
        lastTime = time;
        rafId = requestAnimationFrame(step);
        return;
      }

      if (!lastTime) lastTime = time;
      const delta = time - lastTime;
      lastTime = time;

      const distance = (speed * delta) / 1000;

      if (direction === "left") {
        slider.scrollLeft += distance;
        if (slider.scrollLeft >= slider.scrollWidth - slider.clientWidth) {
          slider.scrollLeft = 0;
        }
      } else {
        slider.scrollLeft -= distance;
        if (slider.scrollLeft <= 0) {
          slider.scrollLeft = slider.scrollWidth - slider.clientWidth;
        }
      }

      rafId = requestAnimationFrame(step);
    }

    function start() {
      if (!rafId) rafId = requestAnimationFrame(step);
    }

    // --- Pause / Resume ---
    slider.addEventListener('mouseenter', () => { paused = true; });
    slider.addEventListener('mouseleave', () => { paused = false; });
    slider.addEventListener('touchstart', () => { paused = true; }, { passive: true });
    slider.addEventListener('touchend', () => { paused = false; });

    start();
  });
});
